<template>
  <div class="app-container">
    <el-card>
      <!-- <div slot="header" class="clearfix">
        <span>{{ '管理分组' }}</span>
      </div> -->
      <div class="filter-container">
        <el-input
          v-model="groupListQuery.title"
          placeholder="请输入关键字"
          clearable
          style="width: 200px;margin-right: 10px;"
          class="filter-item"
          @keyup.enter.native="handleFilter"
        />

        <el-select
          v-model="groupListQuery.status"
          placeholder="状态"
          clearable
          class="filter-item"
          style="width: 80px;margin-right: 10px;"
        >
          <el-option
            v-for="item in statusOptions"
            :key="item.key"
            :label="item.display_name"
            :value="item.key"
          />
        </el-select>

        <!-- <el-select v-model="listQuery.order" style="width: 80px;margin-right: 10px;" class="filter-item" @change="handleFilter">
          <el-option v-for="item in sortOptions" :key="item.key" :label="item.label" :value="item.key" />
        </el-select> -->

        <el-button
          v-waves
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
        >
          {{ '搜索' }}
        </el-button>

        <el-button
          :disabled="!checkPermission(['larke-admin.auth-group.create'])"
          class="filter-item"
          type="primary"
          icon="el-icon-edit"
          @click="handleCreate"
        >
          {{ '添加分组' }}
        </el-button>

        <el-button
          v-permission="['larke-admin.auth-group.index-tree']"
          class="filter-item"
          icon="el-icon-menu"
          @click="handleTree"
        >
          {{ '分组结构' }}
        </el-button>
      </div>

      <el-table
        v-loading="listLoading"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        :data="list"
        class="border-gray"
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column
          min-width="100"
          label="名称"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="100"
          label="类型"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.type_str }}</span>
          </template>
        </el-table-column>

        <el-table-column
          min-width="250"
          prop="leaderName"
          label="组长"
          align="center"
        >
          <template slot-scope="scope">
            <div class="groupbox">
              <div v-for="item,index in scope.row.leaders" :key="index" style="margin-right:10px">
                <el-tag type="success">{{ item.leaderName }}</el-tag>
              </div>
            </div>

          </template>
        </el-table-column>
        <el-table-column
          width="200"
          align="center"
          label="排序"
        >
          <template slot-scope="{row, $index}">
            <div @click.stop="{{editableChangeBtn($index, 'editListorderInput')}}">
              <el-input
                v-if="editable[$index]"
                v-model="row.listorder"
                size="mini"
                class="editListorderInput"
                :disabled="!checkPermission(['larke-admin.auth-group.listorder'])"
                @blur="editableChange($event, row, $index)"
              />
              <span v-else>{{ row.listorder }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="170"
          align="center"
          label="添加时间"
        >
          <template slot-scope="scope">
            <span>
              <i class="el-icon-time" />&nbsp;
              {{ scope.row.createTime | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          class-name="status-col"
          label="状态"
          width="180"
        >
          <template slot-scope="scope">
            <!-- <el-switch
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              :disabled="!checkPermission(['larke-admin.auth-group.enable']) || !checkPermission(['larke-admin.auth-group.disable'])"
              @change="changeStatus($event, scope.row, scope.$index)"
            /> -->
            <span v-if="scope.row.status === 1">启用</span>
            <span v-else>禁用</span>
          </template>
        </el-table-column>

        <el-table-column
          align="left"
          label="操作"
          width="220"
        >
          <template slot-scope="scope">
            <div>
              <el-button
                v-waves
                :disabled="!checkPermission(['larke-admin.auth-group.access'])"
                type="primary"
                size="mini"
                icon="el-icon-setting"
                @click="handleAccess(scope.$index, scope.row)"
              >
                {{ '授权' }}
              </el-button>

              <el-button
                v-waves
                :loading="scope.row.id == loading.detail"
                :disabled="!checkPermission(['larke-admin.auth-group.detail'])"
                type="info"
                size="mini"
                icon="el-icon-info"
                @click="handleDetail(scope.$index, scope.row)"
              >
                {{ '详情' }}
              </el-button>
            </div>

            <div style="margin-top:5px;">
              <el-button
                v-waves
                :disabled="!checkPermission(['larke-admin.auth-group.update'])"
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleEdit(scope.$index, scope.row)"
              >
                {{ '编辑' }}
              </el-button>
              <el-button
                v-waves
                v-permission="['larke-admin.auth-group.delete']"
                :loading="scope.row.id == loading.delete"
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="handleDelete(scope.$index, scope.row)"
              >
                {{ '删除' }}
              </el-button>
            </div>
            <div style="margin-top:5px;">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="setUp(scope.row)"
              >
                设置组长
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="groupListQuery.page"
        :limit.sync="groupListQuery.page_size"
        @pagination="getList"
      />
    </el-card>

    <el-dialog
      title="添加分组"
      :visible.sync="create.dialogVisible"
      :destroy-on-close="true"
      @close="closeCreateDialog"
    >
      <create
        ref="createComponent"
        :item="create"
        @updateList="getList"
      />
    </el-dialog>

    <el-dialog
      title="编辑分组"
      :visible.sync="edit.dialogVisible"
      @close="closeEdit"
    >
      <edit
        ref="editComponent"
        :item="edit"
        @updateList="getList"
      />
    </el-dialog>

    <el-dialog
      title="分组详情"
      :visible.sync="detail.dialogVisible"
    >
      <detail :data="detail.data" />
    </el-dialog>

    <el-dialog
      title="分组授权"
      :visible.sync="access.dialogVisible"
    >
      <access
        ref="accessComponent"
        :item="access"
      />
    </el-dialog>

    <el-dialog
      title="选择管理员"
      :visible.sync="administrators"
      :close-on-click-modal="false"
      @closed="eliminate"
    >
      <!-- <el-autocomplete
        v-model="mGroupLeader.adminId"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入内容"
        @select="handleSelect"
      /> -->
      <el-tag
        v-for="tag in tags"
        :key="tag.id"
        closable
        type="success"
        style="margin-right:10px"
        @close="closeadminr(tag)"
      >
        {{ tag.realName }}
      </el-tag>
      <el-button type="primary" size="mini" @click="chorwe">选择管理员</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="determine">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="绑定员工"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <bandstaff ref="bandstaffview" @bandarr="bandarr" />
    </el-dialog>
  </div>
</template>

<script>
// import md5 from 'js-md5'
import waves from '@/directive/waves' // waves directive
// import { parseTime } from '@/utils'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import permission from '@/directive/permission/index.js' // 权限判断指令
import checkPermission from '@/utils/permission' // 权限判断函数
import Detail from '@/components/Larke/Detail'
import Edit from './components/Edit'
import Create from './components/Create'
import Access from './components/Access'
import bandstaff from './bandstaff.vue'
import {
  getGroupList,
  // getGroupTreeList,
  // getGroupChildrenList,
  getGroupDetail,
  deleteGroup,
  updateGroupSort,
  enableGroup,
  disableGroup,
  setUp
} from '@/api/authGroup'

import { getList } from '@/api/admin.js'
import { groupLeaders, deleteLeaders } from '@/api/authGroup'

export default {
  name: 'AuthGroup',
  components: { Pagination, Detail, Edit, Create, Access, bandstaff },
  directives: { waves, permission },
  filters: {
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      statusOptions: [
        { key: 1, display_name: '启用' },
        { key: 0, display_name: '禁用' }
      ],
      sortOptions: [
        { key: 'ASC', label: '正序' },
        { key: 'DESC', label: '倒叙' }
      ],
      detail: {
        dialogVisible: false,
        data: []
      },
      create: {
        dialogVisible: false
      },
      edit: {
        dialogVisible: false,
        id: ''
      },
      access: {
        id: '',
        title: '',
        dialogVisible: false
      },
      editable: [],
      editableItem: {},
      editableOldSort: 0,
      loading: {
        detail: '',
        delete: ''
      },
      groupListQuery: {
        title: null,
        status: null,
        page: 1,
        page_size: 10
      },
      mGroupLeader: {
        groupId: undefined,
        adminId: undefined
      },
      activeItem: null,
      administrators: false,
      // userids: [],
      dialogVisibler: false,
      tags: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    chorwe() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(this.tags, this.mGroupLeader.groupId)
      })
    },
    async bandarr(arr, sp_strategy_no, arrname) {
      this.dialogVisibler = false
      // this.userids = arr
      this.grourwlist()
    },
    checkPermission,
    getList() {
      this.listLoading = true
      getGroupList(this.groupListQuery).then(response => {
        this.list = response.data.list
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.groupListQuery.page = 1
      this.getList()
    },
    handleCreate() {
      this.create.dialogVisible = true
      // 防止第一次触发获取不到子组件触发方法报错
      if (this.$refs.createComponent) {
        this.$refs.createComponent.getGroupChildrenList()
      }
    },
    handleEdit(index, row) {
      this.edit.dialogVisible = true
      this.edit.id = row.id
      // 防止第一次触发获取不到子组件报错
      if (this.$refs.editComponent) {
        this.$refs.editComponent.getGroupChildrenList()
        this.$refs.editComponent.fetchData()
      }
    },
    closeEdit() {
      this.$refs.editComponent.resetData()
      this.edit.id = ''
    },
    editableChangeBtn(index, className) {
      this.editable = new Array(this.list.length)

      this.editable[index] = true

      this.editableItem = this.list[index]

      this.$set(this.editable, index, true)

      // 让input自动获取焦点
      this.$nextTick(() => {
        var editInputList = document.getElementsByClassName(className)
        editInputList[0].children[0].focus()
      })
    },
    editableChange(e, data, index) {
      this.editable[index] = false

      if (this.editableOldSort === data.listorder) {
        return
      }

      this.editableOldSort = data.listorder

      updateGroupSort(data.id, data.listorder).then(() => {
        this.$message({
          message: '权限排序成功',
          type: 'success',
          duration: 2 * 1000
        })
      })
    },
    // 关闭清空请求参数
    closeCreateDialog() {
      this.$refs.createComponent.resetQueryData()
    },
    handleAccess(index, row) {
      this.access.id = row.id
      this.access.title = row.title
      this.access.dialogVisible = true
      // 防止第一次触发获取不到子组件报错
      if (this.$refs.accessComponent) {
        this.$refs.accessComponent.getGroupChildrenList()
      }
    },
    handleDetail(index, row) {
      this.loading.detail = row.id

      getGroupDetail(row.id).then((res) => {
        this.detail.dialogVisible = true
        const data = res.data

        this.loading.detail = ''

        this.detail.data = [
          {
            name: 'ID',
            content: data.id,
            type: 'text'
          },
          {
            name: '父级ID',
            content: data.parentid,
            type: 'text'
          },
          {
            name: '名称',
            content: data.title,
            type: 'text'
          },
          {
            name: '描述',
            content: data.description,
            type: 'text'
          },
          {
            name: '排序',
            content: data.listorder,
            type: 'text'
          },
          {
            name: '状态',
            content: data.status,
            type: 'boolen'
          },
          {
            name: '更新时间',
            content: data.updateTime,
            type: 'time'
          },
          {
            name: '更新IP',
            content: data.updateTp,
            type: 'text'
          },
          {
            name: '添加时间',
            content: data.createTime,
            type: 'time'
          },
          {
            name: '添加IP',
            content: data.createIp,
            type: 'text'
          }
        ]
      }).catch((err) => {
        this.loading.detail = ''
        return err
      })
    },
    handleTree() {
      this.$router.replace('/auth/group/tree')
    },
    changeStatus(e, data, index) {
      if (data.status === 1) {
        enableGroup(data.id).then(() => {
          this.$message({
            message: '权限启用成功',
            type: 'success',
            duration: 2 * 1000
          })
        })
      } else {
        disableGroup(data.id).then(() => {
          this.$message({
            message: '权限禁用成功',
            type: 'success',
            duration: 2 * 1000
          })
        })
      }
    },
    handleDelete(index, row) {
      const thiz = this
      this.$confirm('确认要删除该权限吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        thiz.loading.delete = row.id

        deleteGroup(row.id).then(() => {
          thiz.loading.delete = ''
          this.$message({
            message: '删除权限成功',
            type: 'success',
            duration: 5 * 1000
            // onClose() {
            //   thiz.list.splice(index, 1)
            // }
          })
          thiz.list.splice(index, 1)
        }).catch(() => {
          thiz.loading.delete = ''
        })
      }).catch(() => {

      })
    },

    async setUp(item) {
      this.administrators = true
      this.mGroupLeader.adminId = item.leaderName || undefined
      this.mGroupLeader.groupId = item.id
      this.activeItem = {
        id: item.leaderAdminId || undefined
      }
      this.grourwlist()
    },
    async grourwlist() {
      const data = await groupLeaders({
        groupId: this.mGroupLeader.groupId
      })
      this.tags = data.data.admins
      console.log('data', data.data)
    },
    async querySearchAsync(queryString, cb) {
      // if (!queryString) {
      //   cb([])
      //   return
      // }
      console.log('queryString', queryString)
      const data = await getList({ name: queryString })
      const newArr = data.data.list.map((item) => {
        return { ...item, value: item.realName, address: item.id }
      })
      cb(newArr)
    },

    handleSelect(item) {
      this.activeItem = item
    },
    async determine() {
      if (!this.mGroupLeader.groupId || !this.mGroupLeader.adminId) {
        this.$message({
          message: this.mGroupLeader.adminId || '请选择管理员',
          type: 'warning'
        })
      }
      await setUp({ ...this.mGroupLeader, adminId: this.activeItem.id })

      this.$message({
        message: '设置成功',
        type: 'success'
      })
      this.eliminate()
      this.getList()
    },

    eliminate() {
      this.mGroupLeader = {
        groupId: undefined,
        adminId: undefined
      }
      this.activeItem = null
      this.administrators = false
    },
    closeadminr(item) {
      this.$confirm(`此操作将解除${item.realName}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        deleteLeaders({
          adminId: item.id,
          groupId: this.mGroupLeader.groupId
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '解除成功!'
          })
          this.grourwlist()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解除'
        })
      })
    }

  }
}
</script>

<style scoped>
.pagination-container {
  padding: 5px 2px;
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.groupbox{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
